import React from "react";
import PropTypes from "prop-types";
import { Image } from "@learningblocks/shared-components";

import GlossaryIcon from "@common/images/Glossary.svg";

const ENTER_KEY = 13;
/**
 * GlossaryOption :
 * - GlossaryOption for RectangleNode
 */
export function GlossaryOption(props) {
  const onClick = () => props.onClick();

  const onKeyDown = (event) => event.keyCode === ENTER_KEY && props.onClick();

  const hoverStyles = props.isOption
    ? {}
    : {
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave,
        style: props.style,
      };
  return (
    <div
      tabIndex={props.tabIndex}
      role="button"
      aria-label="More info"
      onKeyDown={onKeyDown}
      onClick={onClick}
      className={props.className}
      {...hoverStyles}
    >
      <Image src={GlossaryIcon} alt="" />
    </div>
  );
}

GlossaryOption.propTypes = {
  /**
   * Callback for onClick/onKeyDown event
   */
  onSelect: PropTypes.func,
  /**
   * tabIndex
   */
  tabIndex: PropTypes.number,
  /**
   * the word which glossary should be fetched.
   */
  title: PropTypes.string,
};

GlossaryOption.defaultProps = {
  onSelect: undefined,
};
